import type { DefaultTheme } from 'styled-components';

type Device = keyof DefaultTheme['devices'];

const allDevices: Device[] = ['mobile', 'tablet', 'laptop', 'desktop'];

export const getMediaQuery =
  (firstDevice: Device, ...otherDevices: Device[]) =>
  ({ theme }: { theme: DefaultTheme }) => {
    const devices = allDevices.filter(device => [firstDevice, ...otherDevices].includes(device));

    let mediaQuery: string[] = [];
    const mediaQueries: string[] = [];

    devices.forEach(device => {
      const deviceIndex = allDevices.indexOf(device);
      const isLastDeviceIndex = deviceIndex === allDevices.length - 1;

      const hasPrecedingDevice = deviceIndex && devices.includes(allDevices[deviceIndex - 1]);

      if (!hasPrecedingDevice) {
        const minStr = ('min' in theme.devices[device] && theme.devices[device].min) || '';
        if (minStr) {
          mediaQuery[0] = `(min-width: ${minStr})`;
        }
      }

      const hasFollowingDevice = !isLastDeviceIndex && devices.includes(allDevices[deviceIndex + 1]);

      if (!hasFollowingDevice) {
        const maxStr = ('max' in theme.devices[device] && theme.devices[device].max) || '';
        if (maxStr) {
          mediaQuery[1] = `(max-width: ${maxStr})`;
        }

        mediaQueries.push(mediaQuery.filter(Boolean).join(' and '));
        mediaQuery = [];
      }
    });

    // console.log('mediaQuery', `@media ${mediaQueries.join(`, `)}`);

    return `@media ${mediaQueries.join(', ')}`;
  };
